module.exports = __webpack_public_path__ + "img/caret-down.b3b14710.svg";